module.exports = __webpack_public_path__ + "static/media/home-hero.c07c76d0.jpg";